import { parseDate } from "../utilities/parseHelper";
import { DateType } from "./types/index";

/**
 * Класс данных операции выписки карты.
 */
export class CardStatementOperationData {
  /**
   * Дата зачисления/списания.
   */
  public RegDate: string = '';

  /**
   * Дата совершения платежа.
   */
  public CommitTime: string = '';

  /**
   * Код авторизации.
   */
  public AuthCode: string = "";

  /**
   * Уникальный ИД транзакции.
   */
  public UniqueID: string = "";

  /**
   * Сумма.
   */
  public Sum: number = 0;

  /**
   * Комиссия.
   */
  public FeeSum: number = 0;

  /**
   * Сумма транзакции.
   */
  public TransSum: number = 0;

  /**
   * Код валюты.
   */
  public TransCurCode: string = "";

  /**
   * Код продавца.
   */
  public MCC: string = "";

  /**
   * Описание продавца.
   */
  public MCCDesc: string = "";

  /**
   * Урла на картинку для мсс-кода.
   */
  public MCCImageUrl: string = "";

  /**
   * Наименование МСС.
   */
  public MCCName: string = "";

  /**
   * Цвет MCC.
   */
  public MCCColor: string = "";

  /**
   * Описание транзакции.
   */
  public Description: string = "";

  /**
   * Адрес проведения операции.
   */
  public Address: string = "";

  public Status: number = 0;

  /**
   * Код подтверждения
   */
  public ApprovalCode: string = "";

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null) {
    if (src) {
      this.AuthCode = src.AuthCode ?? "";
      this.CommitTime = src.CommitTime == 'null' ? '' : src.CommitTime;
      this.Description = src.Description ?? "";
      this.Status = src.Status ?? 0;
      this.FeeSum = src.FeeSum ?? 0;
      this.MCC = src.MCC ?? "";
      this.MCCName = src.MCCName ?? "";
      this.MCCImageUrl = src.MCCImageUrl ?? "";
      this.MCCColor = src.MCCColor ?? "";
      this.MCCDesc = src.MCCDesc ?? "";
      this.RegDate = src.RegDate ?? "";
      this.Sum = src.Sum ?? 0;
      this.TransCurCode = src.TransCurCode ?? "";
      this.TransSum = src.TransSum ?? 0;
      this.UniqueID = src.UniqueID ?? "";
      this.Address = src.Address ?? "";
      this.ApprovalCode = src.ApprovalCode ?? "";
    }
  }
}
